<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="/#/home">
        <img :src="logo" class="d-inline-block align-top" alt="">
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <locale-dropdown />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="container">
      <!-- Content will be placed here -->
      <slot />
    </div>
  </div>

</template>

<script>
  /* ============
   * Minimal Layout
   * ============
   *
   * Used for the register and login pages.
   *
   * Layouts are used to store a lot of shared code.
   * This way the app stays clean.
   */

  import logo from '../../public/img/logo-small.png';
  import LocaleDropdown from '@/components/LocaleDropdown';

  export default {
    /**
     * The name of the layout.
     */
    name: 'MinimalLayoutWithNav',

    components:{
      LocaleDropdown,
    },

    data() {
      return {
        logo
      }
    }
  };
</script>
